import React, { useEffect, useState } from "react";
import * as Plotly from "plotly.js";
import { useSelector } from "react-redux";

import { Modal } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { PDFViewer } from "@react-pdf/renderer";

import { getAlarmsList } from "api/report";

import getLogger from "utils/logger.util";
import { getReportPreviewEnd, getReportPreviewStart } from "utils/reportUtils";
import { extractSystemId, getFileNameDateTime,getFileNameDate } from "utils/utils";

import PageLoading from "components/PageLoading";
import PieChart from "components/Reports/PieChart";
import { generateReportImageConfig, generateReportPlotConfig } from "components/Reports/ReportConfig";

import PdfRender, { isToShowHeader } from "../PDF/PDFDocument";

import "./index.scss";

const ReportPreview = ({ showPreview, handleClose, reports, layoutID, layoutName }) => {
  const [alarms, setAlarms] = useState(null);
  const [alarmUrl, setAlarmUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const Logger = getLogger("GenerateReport");
  const systemsAsObj = useSelector(state => state.systems.systemsAsObj);

  const getSystemName = () => {
    let systemData;
    const systemId = extractSystemId();
    if (systemsAsObj && systemId) {
      systemData = systemsAsObj[systemId];
      return systemData.systemName;
    }
    return systemId;
  };

  const getLayoutName = () => layoutName + "_" + getFileNameDateTime();
  const getOnlyLayoutName = () => layoutName ;
  const getDate=() => getFileNameDate();
  const plotImage = async report => {
    const plotConfig = { ...generateReportPlotConfig, title: report.Header };
    const plot = await Plotly.react("plotly_div", report.chartData, { ...plotConfig, generateReportImageConfig }, plotConfig);
    const url = await Plotly.toImage(plot, generateReportImageConfig);
    report.url = url;
  };

  const generateReport = async () => {
    try {
      let index = 0;
      while (index < reports.length) {
        if (!reports[index].error && !isToShowHeader(reports[index])) {
          await plotImage(reports[index]);
        }
        index++;
      }
    } catch (err) {
      Logger.log("Error while generating image " + err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        layoutID: layoutID,
        startTime: Date.parse(getReportPreviewStart()) / 1000,
        endTime: Date.parse(getReportPreviewEnd()) / 1000
      };
      try {
        const response = await getAlarmsList(params);
        setAlarms(response);
      } catch (err) {
        Logger.log("Error while fetching alarms " + err);
      } finally {
        generateReport();
      }
    };
    setIsLoading(true);
    fetchData();
  }, [reports]);

  return (
    <>
      <Modal open={showPreview} onClose={handleClose} closeaftertransitionx="true" style={{ zIndex: 99999 }}>
        {isLoading ? (
          <div>
            <PageLoading />
            <div id="plotly_div" className="margin-top-100" />
          </div>
        ) : (
          <div className="flex-jc-center">
            <PieChart alarms={alarms} setAlarmUrl={setAlarmUrl} />
            <PDFViewer className="pdf_viewer">
              {alarmUrl && (
                <PdfRender
                  reports={reports}
                  handleClose={handleClose}
                  alarmUrl={alarmUrl}
                  alarms={alarms}
                  systemName={getSystemName()}
                  title={getOnlyLayoutName()}
                  reportDate={getDate()}
                />
              )}
            </PDFViewer>

            <IconButton className="close_button" colorprimary="white" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ReportPreview;
